import React from "react";
import './Subscriber.scss';
import { closeTroubles } from "../../Menu/MenuSide/menuSideSlice";
import subscribeImage from "../../../styles/svg_subscriber/true_item.svg";
import subscribeImageFalse from "../../../styles/svg_subscriber/false_item.svg";

const Subscriber = (props) => {
    const { dispatch } = props;
    const onClickEnd = () =>{
        dispatch(closeTroubles());
    }
const subscribeOnStarted = (props.subscription ==="started") ?  true: false;    
const subscribeOnFree = (props.subscription ==="free") ?  true: false;

const subscribeOnOne = (props.subscription ==="one year") ?  true: false;


   const renderSubscriberPlan = () => {
        return (
            <div className="items-container">
                <div className={subscribeOnStarted? "main-container-green" : "main-container"}>
                    <div className="text-container">
                        
                        <p className="main-header">Начальный</p>
                        <p className="header">бессрочно</p>
                        <div className="item">
                            <img src={subscribeImageFalse} className ="title-img" alt="title"/>
                            <p className="text">просмотр заметок</p>
                        </div>
                        <div className="item">
                            <img src={subscribeImageFalse} className ="title-img" alt="title"/>
                            <p className="text">прохождение тестов</p>
                        </div>
                        <div className="item">
                            <img src={subscribeImageFalse} className ="title-img" alt="title"/>
                            <p className="text">выполнение задач</p>
                        </div>
                    </div>
                
                    <div className="button-container">
                        <button className={subscribeOnStarted ? "button-green" : "button-common-disabled"} onClick={onClickEnd} 
                        disabled >{!subscribeOnStarted ? 'Не активна':'Активна' } </button>
                    </div>
                    
                </div>
                <div className={subscribeOnFree ? "main-container-green" : "main-container"}>
                    <div className="text-container">
                        
                        <p className="main-header">Пробный</p>
                        <p className="header">7 дней</p>
                        <div className="item">
                            <img src={subscribeImage} className ="title-img" alt="title"/>
                            <p className="text">просмотр заметок</p>
                        </div>
                        <div className="item">
                            <img src={subscribeImage} className ="title-img" alt="title"/>
                            <p className="text">прохождение тестов</p>
                        </div>
                        <div className="item">
                            <img src={subscribeImage} className ="title-img" alt="title"/>
                            <p className="text">выполнение задач</p>
                        </div>
                    </div>
                
                    <div className="button-container">
                        <button className={subscribeOnFree ? "button-green" : "button-common-disabled"} onClick={onClickEnd} 
                        disabled >{!subscribeOnFree ? 'Не активна':'Подписка оформлена' } </button>
                    </div>
                    
                </div>
                <div className={subscribeOnOne ? "main-container-green" : "main-container"}>
                    <div className="text-container">
                        
                        <p className="main-header">Базовый</p>
                        <p className="header">1 год</p>
                        <div className="item">
                            <img src={subscribeImage} className ="title-img" alt="title"/>
                            <p className="text">просмотр заметок</p>
                        </div>
                        <div className="item">
                            <img src={subscribeImage} className ="title-img" alt="title"/>
                            <p className="text">прохождение тестов</p>
                        </div>
                        <div className="item">
                            <img src={subscribeImage} className ="title-img" alt="title"/>
                            <p className="text">выполнение задач</p>
                        </div>
                        <div className="cost">
                            <p className="main-header">500 <span className="rub">₽</span>/год</p>
                        </div>
                    </div>
                
                    <div className="button-container">

                        <button className={subscribeOnOne ? "button-green" : "button-common"} disabled ={!subscribeOnOne ? '' : 'disabled'} 
                        onClick={onClickEnd}>{!subscribeOnOne ? 'Оформить подписку':'Подписка оформлена' } </button>
                    </div>
                    
                </div>
            </div>
        )
   } 
    //RENDER
   // const troublesView = props.troublesView;
    //if (troublesView) {
        return (
            <div className="Subscriber">
                <p className="main-header"> Варианты подписки</p>
                {renderSubscriberPlan()}
                   
            </div>
        )
   // } else return null;
}
export default Subscriber;